import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as dateUtil from '../utils/date-util';

import classes from './BOBDate.module.css';

/**
 *  A component for rendering date in BOB.
 *  This component will handle the error checking, it also provide a default format and a renderer,
 *  which will fallback to HTML5 <time /> tag.
 *
 *  Usage:
 *
 *    <BOBDate
 *        date={new Date()}
 *        format={'YYYY-MM-DD HH:mm:ss'}
 *        render={date => `Here is the date to render: ${date}`}
 *    />
 *
 */

const NOT_AVAILIABLE = 'Not Available';

const BOBDate = ({ date, format, render }) => {
    const [dateTime, setDateTime] = useState(NOT_AVAILIABLE);

    useEffect(() => {
        if (date) {
            setDateTime(dateUtil.format(date, format));
        } else {
            setDateTime(NOT_AVAILIABLE);
        }
    }, [date]);

    return render(dateTime);
};

BOBDate.defaultProps = {
    format: 'M/D/YY h:mm A',
    render: value => {
        return (
            <time className={classes.root} dateTime={value}>
                {value}
            </time>
        );
    }
};

BOBDate.propTypes = {
    format: PropTypes.string,
    render: PropTypes.func,
};

export default BOBDate;
